import { SubstageInstanceStatusValues } from '@scale/shared-types';
import { SubstageInstanceLinkDto } from '@scale/shared/sensorFusion/corpLookupLinkDto';
import LookupIdLink from 'react-scale/dashboard.scale.com/components/SensorFusionLookup/common/LookupIdLink';

export const SubstageInstanceListItem = ({
  substageInstance,
}: {
  substageInstance: SubstageInstanceLinkDto & {
    humanNodeId?: string | undefined;
    status: SubstageInstanceStatusValues;
  };
}) => {
  return (
    <div className="flex flex-col p-2 gap-2">
      <div>
        <span className="font-bold">Substage </span>
        {substageInstance.defName}{' '}
        <LookupIdLink className="inline-block" id={substageInstance.id} />
        <span className="font-normal">({substageInstance.status})</span>
      </div>
      {/* <div className="px-4">
        <span className="font-bold">Status</span> {substageInstance.status}
      </div> */}
      {/* <div className="px-4">
        <span className="font-bold">Type</span> {substageInstance.childTaskType}
      </div> */}
    </div>
  );
};
